'use client'

import Script from 'next/script'

export function NaverTracking() {
  return (
    <>
      <Script
        id="naver-common-sa"
        strategy="afterInteractive"
        dangerouslySetInnerHTML={{
          __html: `var _nasa={};if(window.wcs)_nasa["cnv"]=wcs.cnv;`,
        }}
      />
      <Script
        src="//wcs.naver.net/wcslog.js"
        id="naver-wcs"
        strategy="afterInteractive"
        onLoad={() => {
          if (!window.wcs_add) window.wcs_add = {};
          window.wcs_add['wa'] = 's_68728143e80';
          if (window.wcs_do) window.wcs_do();
        }}
      />
    </>
  )
}
